import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { useSelector } from "@src/store";
import { isPriceTest } from "@src/store/slices/experiences/selectors/price/isPriceTest";
import { getControlGroup } from "@src/store/slices/variations";
import { targetingFaqLink } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const PriceTestNote = () => {
  const priceTest = useSelector(isPriceTest);
  const theme = useTheme();
  const controlGroup = useSelector(getControlGroup);
  if (!priceTest) {
    return null;
  }

  return (
    <Grid item>
      <IgTypography
        variant={"body2"}
        sx={{
          color: theme.palette.text.secondary,
        }}
      >
        Visitors that do not match these conditions will receive the pricing
        treatment of {controlGroup?.name ?? "the control group"}.
        <IgTypography
          variant={"body2"}
          onClick={() => {
            openNewTab(targetingFaqLink, "Targeting FAQs");
          }}
          sx={{ fontWeight: 400 }}
          igStyle={"linkNoBold"}
        >
          {" "}
          Learn more.
        </IgTypography>
      </IgTypography>
    </Grid>
  );
};
